<script setup lang="ts">
import { provide } from 'vue';
import DashboardPanel from '@/modules/dashboard/components/DashboardPanel.vue';
import BrokerUsers from '@/modules/broker-admin/components/BrokerUsers.vue';

// for column state persistence
// @TODO: we should type provide/inject after we migrate all components to composition API
// (https://vuejs.org/guide/typescript/composition-api.html#typing-provide-inject)
provide('gridStateKey', 'BrokerUsersView');
</script>

<template>
  <div>
    <DashboardPanel no-collapse title="users">
      <BrokerUsers />
    </DashboardPanel>
  </div>
</template>

<style lang="scss"></style>
